module.exports = __webpack_public_path__ + "img/Zain-KSA-En.af4b9401.jpg";